import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class IncidentListService {
  static getList(
    pageNumber = 0, 
    pageSize = DEFAULT_ITEMS_PER_PAGE, 
    status = "",
    assigneeId ="",
    priority = "",
    reportedCompanyId = "",
    companyNameId = "",
    typeId = "",
    key="", 
    filter, 
    companyId = 0,
    ) {
    return HttpUtil.get(API_ROUTES.INCIDENTLIST.LIST
      .replace("<pageNumber>", pageNumber)
      .replace("<pageSize>", pageSize)
      .replace(key? "<key>" : "&key=<key>", key)
      .replace("<assignedToMe>", filter === "assignedToMe" ? true : false)
      .replace("<createdByMe>", filter === "createdByMe" ? true : false)     
      .replace("<companyId>", companyId)
      .replace("<typeId>", typeId)
      .replace("<reportedCompanyId>",reportedCompanyId)
      .replace("<status>",status)
      .replace("<priority>",priority)
      .replace("<assigneeId>",assigneeId)
      .replace("<companyNameId>",companyNameId)
      );
  }
 
}